// src/seo/AuthorSEO.js
import { SEO_CONFIG } from './SEOConfig';
import { IMG_BASE_URL } from '../Helpers';

export const getAuthorSEO = (author) => {
    if (!author) return {};

    // Helper: Remove HTML tags from bio to create a clean description
    const stripHtml = (html) => {
        if (!html) return "";
        return html.replace(/<[^>]*>?/gm, '');
    };

    const cleanBio = stripHtml(author.biography).substring(0, 160) + "...";
    const authorImageUrl = author.author_photo ? IMG_BASE_URL + "authors/" + author.author_photo : SEO_CONFIG.baseSchema.logo;
    const authorName = author.author_name || "Author";

    return {
        title: `${authorName} - Author Profile`,
        description: cleanBio || `Read books by ${authorName} published by ${SEO_CONFIG.orgName}.`,
        keywords: `${authorName}, Malayalam author, Uyirmozhy writers, Kerala literature`,
        image: authorImageUrl,

        // Dynamic Schema for a "Person"
        schema: {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": authorName,
            "image": authorImageUrl,
            "description": cleanBio,
            "affiliation": {
                "@type": "Organization",
                "name": SEO_CONFIG.orgName
            }
        }
    };
};